import axios from '~/utils/axios';
import { Draft } from '~/types/Draft';

export const fetchDraft = (draftId: string, resource: string) => {
  return axios.get<Draft>(`/${resource}/drafts/${draftId}`).then((res) => res);
};

export const fetchActiveRecord = (recordId: string, resource: string) => {
  return axios.get(`/${resource}/${recordId}`);
};

export const createDraft = (params: { resource: string; record: any }) => {
  return axios.post(`/${params.resource}/drafts`, params.record).then((res) => res.data);
};

export const submitDraft = (params: { resource: string; draftId: string }) => {
  return axios.post(`/${params.resource}/${params.draftId}/submit`).then((res) => res.data);
};

export const discardDraft = (params: { resource: string; draftId: string }) => {
  return axios.post(`/${params.resource}/${params.draftId}/discard`).then((res) => res.data);
};
